import { ContentState } from "draft-js";
import React, { FC } from "react";

type LinkProps = {
  contentState: ContentState;
  entityKey: string;
  children: React.ReactNode;
};

const Link: FC<LinkProps> = ({ contentState, entityKey, children }) => {
  const { url } = contentState.getEntity(entityKey).getData();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    window.open(url, "_blank");
  };

  return (
    <a
      href={url}
      onClick={handleClick}
      style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  );
};

export default Link;
